export default {

  namespaced: true,

  state: () => ({

    billsReceiveble: {},

    sumCollectToday: {},

    sumOverDue: {},

    sumBillreceivebleTotal: {},

    defaultRate: {},

    sumCanceled: {},
  }),

  getters: {
    getSumCollectToday(state) {
      try {
        return state.sumCollectToday
      } catch (error) {
        return 0
      }
    },

    getsumOverDue(state) {
      try {
        return state.sumOverDue
      } catch (error) {
        return 0
      }
    },

    getSumBillreceivebleTotal(state) {
      try {
        return state.sumBillreceivebleTotal
      } catch (error) {
        return 0
      }
    },

    getDefaultRate(state) {
      try {
        return state.defaultRate
      } catch (error) {
        return 0
      }
    },

    getsumCanceled(state) {
      try {
        return state.sumCanceled
      } catch (error) {
        return 0
      }
    },
  },

  mutations: {

    setStatsCardData(state, data) {
      state.sumCanceled = data.sumCanceled.sum_net_total;
      state.sumOverDue = data.sumOverDue.value_sum;
      state.sumCollectToday = data.sumCollectToday.value_sum;
      state.sumBillreceivebleTotal = data.sumBillreceivebleTotal.sum_net_total;
      state.defaultRate = data.defaultRate;
    },
  },

  actions: {

    async getStatsCardBillsReceiveble({ $axios, commit }, params) {
      await axios.get("/erp/billReceiveble/stats", { params: params })
        .then(response => {
          commit('setStatsCardData', response.data);
        }).catch(error => {
          // console.log(error)
        });
    },

    async getBillsReceiveble({ $axios, commit }, params) {
      const data = await axios.get("/erp/billReceiveble/billReceiveble", { params: params })
      return data

    },

    async getBillReceiveble({ $axios, commit }, id) {
      const data = await axios.get("/erp/billReceiveble/billReceiveble/" + id)
      return data

    },

    async getBillReceivebleReport({ $axios, commit }, params) {
      const data = await axios.get("/erp/billReceiveble/report", { params: params });
      return data
    },
 
    async getBillsReceivebleArchive({ $axios, commit }, params) {
      const data = await axios.get("/erp/billReceiveble/bill-receiveble-archive", { params: params });
      return data
    },
  }
}
